"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ProductImgListArrow = _interopRequireDefault(require("@sprinx/react-com/ProductImgListArrow"));

// local copy from @sprinx/react-com/ProductImgListWithTitle
var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    content: {
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '& > div': {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: function flexBasis(_ref) {
          var cardCount = _ref.cardCount;
          return "".concat(100 / cardCount, "%");
        },
        minWidth: 290
      }
    },
    headline: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      paddingBottom: theme.spacing(2),
      flexWrap: 'wrap'
    },
    arrows: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    title: {},
    container: {}
  };
}, {
  name: 'SxComProductImgListWithTitle'
});

function ProductImgListWithTitle(_ref2) {
  var cardCount = _ref2.cardCount,
      children = _ref2.children,
      pClasses = _ref2.classes,
      className = _ref2.className,
      disableArrows = _ref2.disableArrows,
      title = _ref2.title,
      typographyProps = _ref2.typographyProps,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["cardCount", "children", "classes", "className", "disableArrows", "title", "typographyProps"]);

  var cntRef = _react.default.useRef();

  var _React$useMemo = _react.default.useMemo(function () {
    var rfs = _react.default.Children.map(children, function () {
      return /*#__PURE__*/_react.default.createRef();
    });

    return [rfs, _react.default.Children.map(children, function (ch, idx) {
      return /*#__PURE__*/_react.default.cloneElement(ch, {
        ref: rfs[idx]
      });
    }), _react.default.Children.count(children)];
  }, [children]),
      _React$useMemo2 = (0, _slicedToArray2.default)(_React$useMemo, 3),
      chRefs = _React$useMemo2[0],
      nextChildren = _React$useMemo2[1],
      childrenCount = _React$useMemo2[2];

  var classes = useStyles({
    classes: pClasses,
    cardCount: cardCount
  });

  var _React$useState = _react.default.useState({
    disp: 0,
    disabledLeft: true,
    disabledRight: true
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      disabledLeft = _React$useState2$.disabledLeft,
      disabledRight = _React$useState2$.disabledRight,
      disp = _React$useState2$.disp,
      setDisp = _React$useState2[1];

  var move = _react.default.useCallback(function (pDisp, dir) {
    if (cntRef && cntRef.current) {
      var cntWidth = cntRef.current.offsetWidth; // width containeru (viditelneho)

      var maxLeft = cntRef.current.scrollWidth - cntWidth; // width celkoveho containeru vcetne vsech polozek (hidden)

      var nextDisp = pipe(function (d) {
        return d < 0 ? 0 : d;
      }, function (d) {
        return d >= childrenCount ? childrenCount - 1 : d;
      })(pDisp + dir);
      var delta = chRefs && chRefs[nextDisp] && chRefs[nextDisp].current ? chRefs[nextDisp].current.offsetWidth * dir : 0;
      var left = pipe(function (l) {
        return l < 0 ? 0 : l;
      }, function (l) {
        return l >= maxLeft ? maxLeft : l;
      })(cntRef.current.scrollLeft + delta);
      var dl = {
        disabledLeft: left === 0
      };
      var dr = {
        disabledRight: left === maxLeft
      };
      cntRef.current.scroll({
        left: left,
        top: 0,
        behavior: 'smooth'
      });
      setDisp(function (pd) {
        return (0, _extends2.default)({}, pd, {
          disp: nextDisp
        }, dl, dr);
      });
    }
  }, [cntRef, chRefs, childrenCount]);

  _react.default.useEffect(function () {
    var tm = setTimeout(function () {
      move(0, 0);
    }, 800);
    return function () {
      clearTimeout(tm);
    };
  }, [move]);

  var handleMove = _react.default.useCallback(function (dir) {
    return function () {
      return move(disp, dir);
    };
  }, [disp, move]);

  var disabled = disableArrows || childrenCount <= cardCount;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.headline
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({}, typographyProps, {
    className: classes.title
  }), title), !disabled && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.arrows
  }, /*#__PURE__*/_react.default.createElement(_ProductImgListArrow.default, {
    left: true,
    onClick: handleMove(-1),
    disabled: disabledLeft
  }), /*#__PURE__*/_react.default.createElement(_ProductImgListArrow.default, {
    right: true,
    onClick: handleMove(1),
    disabled: disabledRight
  }))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: cntRef,
    className: classes.content
  }, nextChildren, " ")));
}

process.env.NODE_ENV !== "production" ? ProductImgListWithTitle.propTypes = {
  cardCount: _propTypes.default.number,
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    arrows: _propTypes.default.string,
    container: _propTypes.default.string,
    content: _propTypes.default.string,
    headline: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  disableArrows: _propTypes.default.bool,
  title: _propTypes.default.node,
  typographyProps: _propTypes.default.shape({})
} : void 0;
ProductImgListWithTitle.defaultProps = {
  cardCount: 4,
  children: null,
  classes: undefined,
  className: undefined,
  disableArrows: false,
  title: undefined,
  typographyProps: undefined
};
var _default = ProductImgListWithTitle;
exports.default = _default;